export default "__VITE_ASSET__BpYB9YKS__"